import {
  Box,
  Button,
  Center,
  Container,
  Flex,
  Heading,
  Image,
  Link,
  Text
} from "@chakra-ui/react"
import Benefits from "../components/Benefits"
import CallToAction from "../components/CallToAction"
import Footer from "../components/Footer"

const Investors: React.FC = () => (
  <Box>
    {/* Hero Section */}
    <Container maxW="container.xl" py={20}>
      <Flex flexDir={["column", "row"]} gap={8}>
        <Box w={["100%", "50%", "50%", "50%"]} order={[2, 1]}>
          <Text fontSize="md" color="gray.500">
            FOR INVESTORS
          </Text>
          <Heading
            as="h1"
            size={["3xl", "4xl", "5xl", "5xl"]}
            color="brand.600"
            mb={2}
            fontWeight={700}
          >
            Retrofitting pays off
          </Heading>
          <Text fontSize="xl" color="gray.600" mb={4}>
            We help you build a high-performing, low-risk residential portfolio
            with energy-efficient homes that deliver rental premiums and
            regulatory resilience.
          </Text>
          <Link target="_blank" href="https://form.typeform.com/to/ihdWkvvR">
            <Button
              bg="brand.600"
              size="lg"
              mb={6}
              _hover={{ bg: "brand.700" }}
            >
              Get Early Access
            </Button>
          </Link>
        </Box>
        <Box w={["100%", "50%", "50%", "50%"]} order={[1, 2]}>
          <Center textAlign={"center"} h="100%" alignItems="center">
            <Image
              src="/images/greenflip_product.png"
              alt="GreenFlip Platform"
              w={"100%"}
              maxW={["100%", "500px"]}
            />
          </Center>
        </Box>
      </Flex>
    </Container>
    <Box bg="brand.700">
      <Container maxW="container.xl" py={20} textAlign="center" w={"100%"}>
        <Heading as="h2" size="4xl" color="white" pb={8}>
          Small or big
        </Heading>
        <Box
          w={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          textAlign={"center"}
        >
          <Text
            m="auto"
            maxW={800}
            textAlign={"center"}
            color={"white"}
            fontSize="lg"
          >
            Whether your ticket size is £10k or £100m, our platform connects you
            to both short-term investment opportunities and long-term,
            institutional-grade investments tailored to your risk, return and
            impact criteria.
          </Text>
        </Box>
      </Container>
    </Box>
    {/* How it works */}
    {/* <Box bg="gray.50">
      <HowItWorks />
    </Box> */}
    {/* Benefits */}
    <Benefits />
    {/* Investor */}
    <Box>
      <Container maxW="container.xl" py={20} textAlign="center" w={"100%"}>
        <Heading as="h2" size="4xl" pt={1} pb={6}>
          The opportunity
        </Heading>
        <Text m="auto" fontSize="lg" maxW={800} textAlign={"center"}>
          Institutional ownership of residential property in the UK stands at
          just 3%, compared to 37% in Germany and 41% in the US. However, the UK
          market is rapidly expanding, with £1.5 billion invested in
          single-family rental homes in 2024 alone. <br />
          <br />
        </Text>
        <Text
          m="auto"
          fontSize="xl"
          maxW={800}
          fontWeight="bold"
          textAlign={"center"}
        >
          Our mission is to accelerate this growth by unlocking investment in
          the UK’s existing, globally valued housing stock. Start small, build
          confidence, aggregate retrofits, forward fund, de risk upfront costs
          and scale decarbonisation.
        </Text>
        {/* <a href="mailto:amandeep@greenflip.homes,thomas@greenflip.homes">
          <Button bg="brand.600" size="lg" mt={6} _hover={{ bg: "brand.700" }}>
            Find out more
          </Button>
        </a> */}
      </Container>
    </Box>
    {/* Logos */}
    <Box bg="gray.100" p={20} flexDirection={"row"} display={"flex"}>
      <Center m="auto" gap={100}>
        <Image src="/images/carbon13.png" alt="Carbon13" opacity={60} w={120} />
        <Image
          src="/images/octopus.png"
          alt="Octopus Energy"
          opacity={60}
          w={150}
        />
      </Center>
    </Box>
    {/* Call to Action */}
    <CallToAction />
    {/* Footer */}
    <Footer />
  </Box>
)

export default Investors
